export const BUSINESS = {
  name: "Aledo Welding",
  phoneDisplay: "(304) 951-5776",
  phoneHref: "tel:+13049515776",
  email: "aledowelding@gmail.com",
  established: "2024",
  area: "Fort Worth · Tarrant & Parker County, TX",
  hours: "Mon–Sat 7am–7pm · 24/7 emergency dispatch",
};

export const smsHref = (service) => {
  const lines = [
    `Hi, I need ${service ? service.toLowerCase() : "a welding repair"} in the Fort Worth area.`,
    "",
    "1) Wide photo of the whole item: (attach)",
    "2) Close-up photo of the damage: (attach)",
    "3) What happened / what broke:",
    "4) Repair address (or: I can bring it in):",
    "5) My name:",
  ];
  return `sms:+13049515776?body=${encodeURIComponent(lines.join("\n"))}`;
};

export const NAV_LINKS = [
  { name: "Services", path: "/services" },
  { name: "Service Areas", path: "/service-areas" },
  { name: "Capabilities", path: "/capabilities" },
  { name: "Resources", path: "/resources" },
  { name: "About", path: "/about" },
  { name: "Contact", path: "/contact" },
];
